import { render, staticRenderFns } from "./GraficoFatura.vue?vue&type=template&id=9738dd6c&"
import script from "./GraficoFatura.vue?vue&type=script&lang=ts&"
export * from "./GraficoFatura.vue?vue&type=script&lang=ts&"
import style0 from "./GraficoFatura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports